import React, { Component } from 'react'
import * as moment from 'moment'
import { Table, message } from 'antd'
import { api } from '../../../../services'

export default class extends Component {
  getFilteredUsers () {
    return this.props.users.filter((user) => {
      return user.fullName.toLowerCase().includes(this.props.table.searchString.toLowerCase()) &&
        (this.props.table.searchRoles.length > 0 ? this.props.table.searchRoles.includes(user.role) : true) &&
        (this.props.table.searchGroups.length > 0 ? user.groups.map(group => group.id).some(group => this.props.table.searchGroups.includes(group)) : true)
    })
  }

  handleRowSelect = (keys, rows) => {
    this.props.updateTable({
      keys,
      rows
    })
  }

  componentWillUnmount () {
    this.props.updateTable({
      searchString: '',
      searchRoles: [],
      searchGroups: [],
      keys: [],
      rows: []
    })
  }

  render () {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'fullName',
        key: 'fullName',
        width: '25%',
        sorter: (a, b) => {
          return a.fullName.localeCompare(b.fullName)
        },
        render: (value, record) => {
          return (
            <div className='user-cell'>
              <div className='user-cell__name'>{value}</div>
              <div className='user-cell__email'>{record.email}</div>
              { record.groups.length > 0
                ? <div className='user-cell__groups'>
                  { record.groups.map((group, index) => <div key={index} className='user-cell__group'>{ group.name }</div>) }
                </div> : null }
            </div>
          )
        }
      }, {
        title: 'Role',
        dataIndex: 'role',
        key: 'role',
        width: '15%',
        sorter: (a, b) => {
          return a.role.localeCompare(b.role)
        },
        render: (value, record) => {
          console.log(value)
          return (
            <div className='user-cell'>
              <div className='user-cell__type'><div className={record.activated ? 'user-cell__type-badge user-cell__type-badge_active' : 'user-cell__type-badge user-cell__type-badge_inactive'} />{value === 'ORGANIZATION_ADMIN' ? 'Administrator' : 'User'}</div>
            </div>
          )
        }
      }, {
        title: 'Division',
        dataIndex: 'division',
        key: 'division',
        width: '15%',
        sorter: (a, b) => {
          const _a = a.division ? a.division.name : ''
          const _b = b.division ? b.division.name : ''
          return _a.localeCompare(_b)
        },
        render: (value, record) => {
          return value ? value.name : ''
        }
      }, {
        title: 'Date Created',
        dataIndex: 'timestampCreated',
        key: 'timestampCreated',
        width: '20%',
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          return a.timestampCreated - b.timestampCreated
        },
        render: (value) => {
          return moment(value).format('D MMM YYYY')
        }
      }, {
        title: 'Last Content Update',
        dataIndex: 'timestampLastContentUpdate',
        key: 'timestampLastContentUpdate',
        width: '25%',
        sorter: (a, b) => {
          return a.timestampLastContentUpdate - b.timestampLastContentUpdate
        },
        render: (value, record) => {
          return (
            record.verification.verified
              ? moment(value).format('D MMM YYYY')
              : <div className='user-invite'>
                <div className='user-invite__date'>Invited { moment(record.timestampCreated).format('MMM D, hh:mm A') }</div>
                <div className='user-invite__button' onClick={() => {
                  api.user.resendInvitation(record.id)
                    .then(() => message.success('Invite successfully sent'))
                    .catch(() => message.error('Invitation was not sent'))
                }}>Resend</div>
              </div>
          )
        }
      }
    ]

    const { keys } = this.props.table

    const rowSelection = {
      selectedRowKeys: keys,
      onChange: this.handleRowSelect
    }

    const { loading } = this.props

    return (
      <Table
        loading={loading}
        rowKey={record => record.id}
        rowSelection={rowSelection}
        dataSource={this.getFilteredUsers()}
        columns={columns} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Users/components/TableUsers/TableUsers.jsx